const initState = { browse: 0, browseAll: 0, activity: 0 }

export const setBrowsePosition = (position) => {
  initState.browse = position
  initState.browseAll = 0
  initState.activity = 0
  initState.challenges = 0
  initState.browseSearch = 0
}

export const getBrowsePosition = () => {
  return initState.browse
}

export const setBrowseAllPosition = (position) => {
  initState.browseAll = position
}

export const getBrowseAllPosition = () => {
  return initState.browseAll
}

export const setActivityPosition = (position) => {
  initState.activity = position
}

export const getActivityPosition = () => {
  return initState.activity
}

export const setChallengesPosition = (position) => {
  initState.challenges = position
}

export const getChallengesPosition = () => {
  return initState.challenges
}

export const setBrowseSearchPosition = (position) => {
  initState.browseSearch = position
}

export const getBrowseSearchPosition = () => {
  return initState.browseSearch
}

export const clearPositionState = () => {
  initState.browse = 0
  initState.browseAll = 0
  initState.activity = 0
  initState.challenges = 0
  initState.browseSearch = 0
}
